export class ListMPARequestsRequestFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "MPARequestStatus",
            "format": ""
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "MPAOperationType",
            "format": ""
        },
        {
            "name": "requesterUserId",
            "baseName": "requesterUserId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "excludeMyRequests",
            "baseName": "excludeMyRequests",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMPARequestsRequestFilters.attributeTypeMap;
    }
    constructor() {
    }
}
